<div class="paging-controls" *ngIf="totalItems">
  <div class="flex items-center gap-1">
    <p class="table-footer-left-content">
      {{ 'common.visibility' | translate }}
    </p>
    <p class="table-footer-left-num">
      <span class="text-primary font-medium">
        <!-- {{ (currentPage || 1) * (itemsPerPage || 0) - (itemsPerPage || 0) + 1 }}
        - -->
        {{
          Math.min((currentPage || 1) * (itemsPerPage || 0), totalItems || 0)
        }}</span
      >/{{ totalItems || 0 }}
    </p>

    <div class="ml-2">
      <vdr-items-per-page-controls
        [itemsPerPage]="itemsPerPage"
        (itemsPerPageChange)="itemsPerPageChange.emit($event)"
      ></vdr-items-per-page-controls>
    </div>
  </div>

  <pagination-template
    #p="paginationApi"
    (pageChange)="pageChange.emit($event)"
    [id]="id"
  >
    <ul>
      <li class="pagination-previous">
        <button
          class="button"
          [disabled]="currentPage === 1"
          (click)="pageChange.emit(currentPage - 1)"
          (keyup.enter)="pageChange.emit(currentPage - 1)"
          tabindex="0"
        >
          <img
            class="size-5"
            src="assets/icons/icn-chevron-left.svg"
            alt="icn-chervon-left"
          />
        </button>
      </li>

      <li
        *ngFor="let page of getVisiblePages()"
        class="page-number-button flex items-center"
        [class.current]="currentPage === page"
      >
        <ng-container *ngIf="page !== '...'">
          <button
            class="button"
            (click)="pageChange.emit(page)"
            (keyup.enter)="pageChange.emit(page)"
            tabindex="0"
          >
            {{ page }}
          </button>
        </ng-container>
        <span *ngIf="page === '...'">...</span>
      </li>

      <li class="pagination-next">
        <button
          class="button"
          [disabled]="
            currentPage === getTotalPages(totalItems, itemsPerPage).length
          "
          (click)="pageChange.emit(currentPage + 1)"
          (keyup.enter)="pageChange.emit(currentPage + 1)"
          tabindex="0"
        >
          <img
            class="size-5"
            src="assets/icons/icn-chevron-right.svg"
            alt="icn-chervon-right"
          />
        </button>
      </li>
    </ul>
  </pagination-template>
</div>
